// Module/section hierarchy for ticket creation form.
// Mirrors the structure from apps/v5/src/components/base/AppsSidebar/appsConfig.tsx
// but without JSX icons and i18n dependencies. Should be kept in sync when the sidebar changes.

export interface ModuleSectionOption {
  id: string;
  label: string;
}

export interface ModuleOption {
  id: string;
  label: string;
  sections: ModuleSectionOption[];
}

export const MODULE_OPTIONS: ModuleOption[] = [
  {
    id: "rastreo-telemetria",
    label: "Gestión de Flota",
    sections: [
      { id: "lite", label: "Mapa de Unidades" },
      { id: "admin", label: "Administración de Flotilla" },
      { id: "reportes", label: "Reportes y Análisis" },
      { id: "torre-control", label: "Torre de Control" },
      { id: "inspecciones", label: "Inspecciones" },
      { id: "fleet-integradores", label: "Integradores" },
      { id: "mantenimiento-vehiculos", label: "Mantenimiento de Vehículos" },
      { id: "passenger-management", label: "Gestión de Pasajeros" },
    ],
  },
  // {
  //   id: "point-of-sale",
  //   label: "Punto de Venta",
  //   sections: [
  //     { id: "pos-cashier", label: "Cajero POS" },
  //     { id: "pos-products", label: "Productos" },
  //     { id: "pos-inventory", label: "Inventario" },
  //     { id: "pos-coupons", label: "Cupones" },
  //     { id: "pos-orders", label: "Órdenes" },
  //     { id: "pos-ecommerce", label: "E-commerce" },
  //   ],
  // },
  // {
  //   id: "crm",
  //   label: "CRM",
  //   sections: [],
  // },
  // {
  //   id: "marketing",
  //   label: "Marketing",
  //   sections: [],
  // },
  {
    id: "service-desk",
    label: "Service Desk",
    sections: [{ id: "service-desk", label: "Mesa de Servicio" }],
  },
  {
    id: "administracion",
    label: "Administración de la cuenta",
    sections: [
      { id: "facturacion", label: "Licencias y Facturación" },
      { id: "servicios", label: "Entrega de Servicio" },
      { id: "mapon", label: "Mapon" },
      { id: "wialon", label: "Wialon" },
      { id: "servicios-tecnicos", label: "Servicios Técnicos" },
      { id: "ajustes", label: "Ajustes" },
      { id: "support", label: "Soporte" },
    ],
  },
  {
    id: "bases-y-propiedades",
    label: "Bases y Propiedades",
    sections: [
      { id: "bases", label: "Bases" },
      { id: "amenidades", label: "Amenidades" },
      { id: "truck-yard", label: "Patio de Maniobras" },
      { id: "reservas", label: "Reservas" },
      { id: "activos", label: "Activos" },
    ],
  },
  {
    id: "internos",
    label: "Sistemas Internos",
    sections: [
      { id: "reseller-admin", label: "Admin Reseller" },
      { id: "cobranza", label: "Cobranza" },
      { id: "dashboards", label: "Dashboards" },
      { id: "ai", label: "AI" },
      { id: "xml", label: "XML" },
      { id: "integradores", label: "Integradores" },
      { id: "compras", label: "Compras" },
      { id: "logistica", label: "Logística" },
    ],
  },
  {
    id: "access-control",
    label: "Access Control",
    sections: [],
  },
  // {
  //   id: "comunity",
  //   label: "Comunity",
  //   sections: [],
  // },
  // {
  //   id: "cargo-market",
  //   label: "Cargo Market",
  //   sections: [],
  // },
  // {
  //   id: "gestion-staff",
  //   label: "Gestión de Staff",
  //   sections: [],
  // },
  {
    id: "otro",
    label: "Otro / No estoy seguro",
    sections: [],
  },
];
